import { container } from '@shared/common/dependency-injection/domain/container';
import { CommunicationKitModuleRoutes } from '@client/feature/communication-kit/application/routes/communication-kit.module-routes';

export const communicationKitRoutes = new CommunicationKitModuleRoutes(container).getRoutes();
